import { apiCall } from './gqlClient';
const GETPROVIDERBUNDLES_QUERY = "\n  query getProviderBundles {\n    getProviderBundles\n    {\n      id\n\t\t\tuserBundleId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\tduration\n\t\t\tdurationType\n\t\t\tactive\n      ...fragments\n    }\n  }";
export const getProviderBundlesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETPROVIDERBUNDLES_QUERY,
    variables: {},
    fragments
  });
};
const GETUSERBUNDLES_QUERY = "\n  query getUserBundles($userId: Int, $customerId: Int) {\n    getUserBundles(userId: $userId, customerId: $customerId)\n    {\n      id\n\t\t\tuserBundleId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\tduration\n\t\t\tdurationType\n\t\t\tactive\n      ...fragments\n    }\n  }";
export const getUserBundlesApiCall = async function (_ref) {
  let {
    userId,
    customerId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERBUNDLES_QUERY,
    variables: {
      userId,
      customerId
    },
    fragments
  });
};
const GETMYBUNDLES_QUERY = "\n  query getMyBundles {\n    getMyBundles\n    {\n      id\n\t\t\tuserBundleId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\tduration\n\t\t\tdurationType\n\t\t\tactive\n      ...fragments\n    }\n  }";
export const getMyBundlesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMYBUNDLES_QUERY,
    variables: {},
    fragments
  });
};
const GETBUNDLEBYID_QUERY = "\n  query getBundleById($id: String!) {\n    getBundleById(id: $id)\n  }";
export const getBundleByIdApiCall = async _ref2 => {
  let {
    id
  } = _ref2;
  return apiCall({
    query: GETBUNDLEBYID_QUERY,
    variables: {
      id
    }
  });
};
const GETUSERBUNDLEBYID_QUERY = "\n  query getUserBundleById($id: String!) {\n    getUserBundleById(id: $id)\n  }";
export const getUserBundleByIdApiCall = async _ref3 => {
  let {
    id
  } = _ref3;
  return apiCall({
    query: GETUSERBUNDLEBYID_QUERY,
    variables: {
      id
    }
  });
};
const GETBUNDLEITEMS_QUERY = "\n  query getBundleItems($id: String!) {\n    getBundleItems(id: $id)\n  }";
export const getBundleItemsApiCall = async _ref4 => {
  let {
    id
  } = _ref4;
  return apiCall({
    query: GETBUNDLEITEMS_QUERY,
    variables: {
      id
    }
  });
};
const GETCUSTOMERBUNDLEITEMS_QUERY = "\n  query getCustomerBundleItems($userBundleId: String!) {\n    getCustomerBundleItems(userBundleId: $userBundleId)\n  }";
export const getCustomerBundleItemsApiCall = async _ref5 => {
  let {
    userBundleId
  } = _ref5;
  return apiCall({
    query: GETCUSTOMERBUNDLEITEMS_QUERY,
    variables: {
      userBundleId
    }
  });
};
const GETMYBUNDLEITEMS_QUERY = "\n  query getMyBundleItems($userBundleId: String!) {\n    getMyBundleItems(userBundleId: $userBundleId)\n  }";
export const getMyBundleItemsApiCall = async _ref6 => {
  let {
    userBundleId
  } = _ref6;
  return apiCall({
    query: GETMYBUNDLEITEMS_QUERY,
    variables: {
      userBundleId
    }
  });
};
const GETPROVIDERMEMBERSHIPBUNDLES_QUERY = "\n  query getProviderMembershipBundles {\n    getProviderMembershipBundles\n  }";
export const getProviderMembershipBundlesApiCall = async () => apiCall({
  query: GETPROVIDERMEMBERSHIPBUNDLES_QUERY,
  variables: {}
});
const GETALLMEMBERSHIPSASSIGNEDTOABUNDLE_QUERY = "\n  query getAllMembershipsAssignedToABundle {\n    getAllMembershipsAssignedToABundle\n  }";
export const getAllMembershipsAssignedToABundleApiCall = async () => apiCall({
  query: GETALLMEMBERSHIPSASSIGNEDTOABUNDLE_QUERY,
  variables: {}
});
const CREATEMEMBERSHIPBUNDLE_QUERY = "\n  mutation createMembershipBundle($request: BundleMembershipInput!) {\n    createMembershipBundle(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createMembershipBundleApiCall = async function (_ref7) {
  let {
    request
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEMEMBERSHIPBUNDLE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEBUNDLE_QUERY = "\n  mutation updateBundle($request: BundleUpdateInput!) {\n    updateBundle(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateBundleApiCall = async function (_ref8) {
  let {
    request
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEBUNDLE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const TOGGLEBUNDLESTATUS_QUERY = "\n  mutation toggleBundleStatus($id: String!, $value: Boolean!) {\n    toggleBundleStatus(id: $id, value: $value)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const toggleBundleStatusApiCall = async function (_ref9) {
  let {
    id,
    value
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLEBUNDLESTATUS_QUERY,
    variables: {
      id,
      value
    },
    fragments
  });
};
const ARCHIVEBUNDLE_QUERY = "\n  mutation archiveBundle($id: String!) {\n    archiveBundle(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const archiveBundleApiCall = async function (_ref0) {
  let {
    id
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVEBUNDLE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const ADDMEMBERSHIPBUNDLETOUSER_QUERY = "\n  mutation addMembershipBundleToUser($request: AddMembershipBundleInput!) {\n    addMembershipBundleToUser(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const addMembershipBundleToUserApiCall = async function (_ref1) {
  let {
    request
  } = _ref1;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ADDMEMBERSHIPBUNDLETOUSER_QUERY,
    variables: {
      request
    },
    fragments
  });
};